import { createSlice } from '@reduxjs/toolkit';
import * as yup from 'yup';
import { EmailSchema } from './yupSchemas';
const initialState = {};
const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setForm: (state, action) => {
            state.form = action.payload;
        },
    },
});
export default userSlice.reducer;
export const { setForm } = userSlice.actions;
export const UserSchema = yup.object().shape({
    etunimi: yup.string().required('validaatio_pakollinen'),
    sukunimi: yup.string().required('validaatio_pakollinen'),
    paakayttajaEmail: EmailSchema,
    asiointikieli: yup.mixed().oneOf(['fi', 'sv']).required('validaatio_pakollinen'),
    info: yup.string().optional(),
});
